export default "__VITE_ASSET__BQMshUNo__"